/** 主页table列表,报价单列表*/
export const PRICEMANAGEMENT_LIST = {
  url: 'quote/manage/select/quote/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 中标详情-商品列表*/
export const PRICEMANAGEMENT_BIDDINGDETAIL = {
  url: 'quote/manage/select/bidding/biddingDetail',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 议价详情-商品列表*/
export const PRICEMANAGEMENT_BARGAINDETAIL = {
  url: 'quote/manage/select/bargain/bargainDetail',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 报价详情-商品列表*/
export const PRICEMANAGEMENT_QUOTEDETAIL = {
  url: 'quote/manage/select/quote/quoteDetail',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 报价修改报价*/
export const PRICEMANAGEMENT_REPORT = {
  url: 'quote/manage/quote/items/updateOrSaveItem',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 报价单各个状态数量*/
export const PRICEMANAGEMENT_DETAIL_TOP_TOTAL = {
  url: 'quote/manage/select/quote/statusCount',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 首页报价单和议价单数量*/
export const PRICEMANAGEMENT_DETAIL_COUNT = {
  url: 'quote/manage/select/quoteAndBargain/count',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 报价详情-日志过程记录*/
export const PRICEMANAGEMENT_DETAIL_LOG = {
  url: 'quote/manage/select/process/log',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 提交报价或者修改报价*/
export const PRICEMANAGEMENT_DETAIL_QUOTATION = {
  url: 'quote/manage/quote/submitOrUpdateQuotation',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 过程记录详情*/
export const PRICEMANAGEMENT_DETAIL_BOTTOM_LOGDETAIL = {
  url: 'quote/manage/quote/process/log/detail',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 报价缓存*/
export const PRICEMANAGEMENT_DETAIL_TABLECACHE = {
  url: 'quote/manage/quote/items/cache',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 同意或拒绝按钮: 1-同意 2-拒绝*/
export const PRICEMANAGEMENT_DETAIL_COMMIT = {
  url: 'quote/manage/bargain/commit',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
